import { Dispatch, createReducer, createAction } from '@reduxjs/toolkit';
import LeadParams from 'types/Apis/LeadParams';
import { favoriteAddedByVinOnly } from './favorites';

const leadSubmitted = createAction<LeadParams>('leadSubmissions/leadSubmitted');

export function logLeadSubmitted(leadParams: LeadParams) {
  return async (dispatch: Dispatch): Promise<void> => {
    dispatch(favoriteAddedByVinOnly({ vin: leadParams.lead.vin }));
    dispatch(leadSubmitted(leadParams));
  };
}

export const leadSubmissionsReducer = createReducer<LeadParams[]>([], (builder) => {
  builder.addCase(leadSubmitted, (state, action) => {
    return [...state, action.payload];
  });
});
